var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intro px-6 md:px-10 lg:px-12 xl:px-16"},[_c('AppHeading',{attrs:{"level":2,"heading":_vm.heading}}),_c('AppContent',{attrs:{"content":_vm.content}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }